/**
 * User API — typed wrappers around legacy userApi.js.
 */
import { changePassword as legacyChangePassword, getCurrentAuthenticatedUser } from '../apiServices/authApi';
import {
  updateUserName as legacyUpdateUserName,
  updateUserEmail as legacyUpdateUserEmail,
} from '../apiServices/userApi';

export async function changePassword(
  oldPassword: string,
  newPassword: string,
): Promise<void> {
  const user = await getCurrentAuthenticatedUser();
  await legacyChangePassword(user, oldPassword, newPassword);
}

export async function updateUserName(firstName: string, lastName: string): Promise<void> {
  await legacyUpdateUserName(firstName, lastName);
}

export async function updateUserEmail(email: string, workspaceId: string): Promise<void> {
  await legacyUpdateUserEmail(email, workspaceId);
}
